import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=6fded704&scoped=true"
import script from "./loader.ts?vue&type=script&lang=js&external"
export * from "./loader.ts?vue&type=script&lang=js&external"
import style0 from "./loader.scss?vue&type=style&index=0&id=6fded704&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fded704",
  null
  
)

export default component.exports